import { Button, Div, Flex, Gutter, Input, OptionListOption, RadioButton, Title } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import { Errors } from '../utils';

import styles from './RegionSelection.module.scss';

interface RegionSelectionProps {
  loadingPim: boolean;
  regions: OptionListOption[];
  initialRegionSelected: string;
  setInitialRegionSelected: (region: string) => void;
  initialBusinessId: string | undefined;
  setInitialBusinessId: (businessId: string) => void;
  customerBusinessIdForNorwayError: string | undefined;
  handleNextInRegionSelectionPhase: () => void;
  setCustomerOrgValidationErrors: (error: Errors | undefined) => void;
}

export default function RegionSelection(props: RegionSelectionProps) {
  const {
    loadingPim,
    regions,
    initialRegionSelected,
    setInitialRegionSelected,
    initialBusinessId,
    setInitialBusinessId,
    customerBusinessIdForNorwayError,
    handleNextInRegionSelectionPhase,
    setCustomerOrgValidationErrors,
  } = props;
  const { t } = useTranslation('organizationForm');

  return (
    <>
      <form
        name="region-selection"
        onSubmit={e => {
          e.preventDefault();
          handleNextInRegionSelectionPhase();
        }}
      >
        <Div padding={{ size: 'lg' }} boxShadow="md">
          <Title size={'sm'}>{t('regionSelection.title')}</Title>
          <Gutter size="layout-5" />
          <Flex>
            {regions.map(region => (
              <RadioButton
                key={region.value}
                value={region.value}
                checked={initialRegionSelected === region.value}
                label={region.label}
                onChange={() => {
                  setCustomerOrgValidationErrors(undefined);
                  setInitialRegionSelected(region.value);
                }}
                padding={{ right: 'md' }}
              />
            ))}
          </Flex>
          <Gutter size="layout-5" />
          <Div className={styles['customer-organization-form__region-selection__input']}>
            <Input
              id="region-selection-business-id"
              label={t('regionSelection.businessIdInputLabel')}
              onChange={(_event, value) => {
                setCustomerOrgValidationErrors(undefined);
                setInitialBusinessId(value);
              }}
              value={initialBusinessId || ''}
              required={true}
              errorText={customerBusinessIdForNorwayError}
            />
          </Div>
        </Div>
        <Gutter size="layout-5" />
        <Flex>
          <Button
            className="telia-button--primary"
            variant="primary"
            type="submit"
            disabled={loadingPim || !initialBusinessId || !initialRegionSelected}
          >
            {t('nextButton')}
          </Button>
        </Flex>
      </form>
      <Gutter size="layout-5" />
    </>
  );
}
